import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { FAQAccordion } from '../components/faq/FAQAccordion';
import { FAQCta } from '../components/faq/FAQCta';

export default function FAQ() {
    return (
        <div data-testid="faq-page">
            <Helmet>
                <title>FAQ - White Glove Hiring</title>
                <meta name="description" content="Straight answers to the most common questions about White Glove Hiring - pricing, what's included, the minimum commitment, the replacement guarantee, and more." />
                <meta property="og:title" content="Frequently Asked Questions - White Glove Hiring" />
                <meta property="og:description" content="Everything you need to know about the program, pricing, timeclock audits, add-ons, and the buyout option. Straight answers." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/faq`} />
                <meta property="og:image" content={OG_IMAGE} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/faq`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">Questions & Answers</p>
                        <h1 className="font-montserrat font-black text-5xl md:text-6xl text-white tracking-tight leading-tight">
                            Frequently Asked Questions
                        </h1>
                        <p className="text-gray-300 text-lg mt-5 max-w-xl leading-relaxed">
                            Straight answers to the questions we hear most often.
                        </p>
                    </motion.div>
                </div>
            </section>

            <FAQAccordion />
            <FAQCta />
        </div>
    );
}
